import COUNTRIES from 'products/nomad_insurance/assets/data/countries';
import US_STATES from 'assets/data/us-states';

export const COUNTRY_OPTIONS = Object.keys(COUNTRIES)
  .map((country) => ({
    value: country,
    label: COUNTRIES[country]
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const US_STATE_OPTIONS = Object.values(US_STATES).map((state) => ({
  value: state.name,
  label: state.name
}));
